import React, { useEffect } from 'react';
import './index.css';

const i = (props: any) => {
  useEffect(() => { }, []);

  return (
    <h3 className="tag-i" id={props.id} data-tag={props.tag} data-st={props.st} data-et={props.et}>
      {props.children}(段落标题#i)
    </h3>
  );
};

export default i;
